import { Box, Typography } from '@mui/material'
import InCardStack from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import ProfileAvatar from 'components/atoms/ProfileAvatar'
import { getLocalUser } from 'utils/localStorage'
import { formatTime, formatDayMonthDay } from 'utils/formatDateTime'
import { ReactComponent as NoteTakerIcon } from 'assets/images/noteTaker.svg'
import { ReactComponent as NoNoteTakerIcon } from 'assets/images/noNoteTaker.svg'
import { Tag } from 'components/atoms/Text'
import { eventTitle, eventStarted, eventEnded } from 'utils/eventUtils'
import { IconButtonWithTooltip } from 'components/atoms/button/StyledButton'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MY_CONTACT } from 'routes/constants'
import deletedUserImage from 'assets/images/deletedUser.svg'
import ImageContainer from 'components/atoms/container/ImageContainer'

const UserMeetingTitle = ({
  event,
  connection,
  titleVariant = 'h1',
  containerProps = {},
  avatarSize = 72,
  showNoteTakerIcon = true
}) => {
  const { t } = useTranslation()
  const navigation = useNavigate()
  const user = getLocalUser()
  const eventHasStarted = eventStarted(event)
  const eventHasEnded = eventEnded(event)

  const goToContactPage = () => {
    if (event?.userConnectionEvent?.userConnectionId && !connection.deletedAt)
      navigation(
        `${MY_CONTACT}/${event.userConnectionEvent.userConnectionId}`,
        { state: { from: true } }
      )
  }
  const Avatar = ({ user, clickable = false }) => (
    <Box
      onClick={clickable ? goToContactPage : null}
      sx={{
        borderRadius: 25,
        border: `2px solid ${colors.White}`,
        zIndex: 1,
        cursor: clickable ? 'pointer' : 'default'
      }}>
      {user.deletedAt ? (
        <ImageContainer
          src={deletedUserImage}
          alt='Deleted User'
          sx={{ width: avatarSize, height: avatarSize }}
        />
      ) : (
        <ProfileAvatar user={user} size={avatarSize} />
      )}
    </Box>
  )

  return (
    <>
      <RowStack spacing={12} width='unset' {...containerProps}>
        <RowStack spacing={-4} width={'auto'}>
          <Avatar user={user} />
          <Avatar user={connection} clickable={!connection.deletedAt} />
        </RowStack>
        <InCardStack spacing={0} alignItems={'flex-start'}>
          <RowStack spacing={4} width={'auto'}>
            <Typography
              variant={titleVariant}
              onClick={goToContactPage}
              sx={{ cursor: !connection.deletedAt ? 'pointer' : 'default' }}>
              {eventTitle(connection, t)}
            </Typography>
            {showNoteTakerIcon && (
              <>
                <IconButtonWithTooltip
                  title={
                    event.botId
                      ? t('myTeam.noteTakerAddedToMeeting')
                      : t('myTeam.noteTakerNotAddedToMeeting')
                  }
                  toolTipSx={{
                    paddingX: 6,
                    paddingY: 4,
                    textAlign: 'center'
                  }}
                  icon={event.botId ? <NoteTakerIcon /> : <NoNoteTakerIcon />}
                  iconContainerProps={{
                    size: 24
                  }}
                />
                <Tag
                  sx={{
                    padding: 2,
                    lineHeight: '120%',
                    background: eventHasEnded
                      ? colors.Peach200
                      : colors.GoldenYellow100
                  }}>
                  {eventHasEnded
                    ? t('myTeam.finished')
                    : eventHasStarted
                      ? t('myTeam.inProgress')
                      : t('myTeam.prepare')}
                </Tag>
              </>
            )}
          </RowStack>

          <RowStack spacing={4}>
            <Typography>{formatDayMonthDay(event.startTime)}</Typography>
            <Typography fontSize={15}>{' at '}</Typography>
            <Typography>{formatTime(event.startTime)}</Typography>
            <Typography>{' - '}</Typography>
            <Typography>{formatTime(event.endTime)}</Typography>
          </RowStack>
        </InCardStack>
      </RowStack>
    </>
  )
}

export default UserMeetingTitle
